import { render, staticRenderFns } from "./ReviewedBeerDash.vue?vue&type=template&id=d88e944c&"
import script from "./ReviewedBeerDash.vue?vue&type=script&lang=js&"
export * from "./ReviewedBeerDash.vue?vue&type=script&lang=js&"
import style0 from "@/assets/styles/components/beer-dash.less?vue&type=style&index=0&lang=less&"
import style1 from "./ReviewedBeerDash.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports